module.exports = __webpack_public_path__ + "img/logo.f49a4d40.svg";